import { CheckCircle, XCircle } from "lucide-react";

interface ScanStatusIconsProps {
    status: "idle" | "success" | "error" | "complete";
}

/**
 * Preloaded success/error/complete icons — always in DOM, toggled via CSS class.
 * Place inside scan-centre, before the scan-command div.
 */
const ScanStatusIcons = ({ status }: ScanStatusIconsProps) => (
    <>
        <div className={`scan-status-icon scan-status-success ${status === "success" ? "scan-status-active" : ""}`}>
            <CheckCircle strokeWidth={3} />
        </div>
        <div className={`scan-status-icon scan-status-complete ${status === "complete" ? "scan-status-active" : ""}`}>
            <CheckCircle strokeWidth={3} />
        </div>
        <div className={`scan-status-icon scan-status-error ${status === "error" ? "scan-status-active" : ""}`}>
            <XCircle strokeWidth={2} />
        </div>
    </>
);

export default ScanStatusIcons;
